export default "/_next/static/images/richard-dibona-4ecd7d8e880813c76541e1cd6d06cc23.png";